import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('UpperHeaderController', UpperHeaderController);

    function UpperHeaderController(
        $state,
        $window,
        AuthFactory,
        LocalStorageService,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.logout = logout;
            vm.addActive = addActive;
            vm.removeActive = removeActive;
            vm.toggleActive = toggleActive;
            getCurrentUser();
        }

        function logout() {
            AuthFactory.authLogout().then(function () {
                LocalStorageService.removeLocalData();
                toastr.success('Wylogowano.');
                $state.go('login');
            });
        }

        function getCurrentUser() {
            AuthFactory.readMe().then(
                function (response) {
                    LocalStorageService.saveObject(
                        'common/user',
                        response.data
                    );

                    vm.displayMyName = LocalStorageService.getObject(
                        'common/user'
                    ).first_name;
                    vm.displayMyEmail = LocalStorageService.getObject(
                        'common/user'
                    ).email;
                },
                function (error) {
                    if (error.status === 401) {
                        LocalStorageService.removeLocalData();
                        $state.go('login');
                    }
                }
            );
        }

        function addActive() {
            if ($window.innerWidth > 768) {
                angular.element(document).find('.sub-menu').addClass('active');
            }
        }

        function removeActive() {
            angular.element(document).find('.sub-menu').removeClass('active');
        }

        function toggleActive() {
            if ($window.innerWidth < 768) {
                angular
                    .element(document)
                    .find('.sub-menu')
                    .toggleClass('active');
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/header/upper_header.controller.ts